<mat-card>
  <mat-card-title>{{ '+USER_DETAILS.CONTACT_DETAILS.TITLE' | translate }}</mat-card-title>
  <mat-card-content>
    <form [formGroup]="formGroup" class="flex flex-col">
      <div
        class="flex flex-row"
        [matTooltip]="
          isOmaUser ? ('+USER_DETAILS.PERSONAL_DETAILS.OMA_EDIT_DISABLED' | translate) : null
        "
      >
        <mat-form-field
          mat-input-height-large-label
          class="flex-[100%] max-w-[100%]"
          id="telephone"
        >
          <mat-label>{{ '+USER_DETAILS.PERSONAL_DETAILS.TELEPHONE' | translate }}</mat-label>
          <input
            gtm="onTextField"
            gtmId="telephone"
            gtmAction="Region"
            gtmCategory="userContactDetails"
            [gtmOn]="['change', 'focus', 'blur']"
            matInput
            [formControl]="formGroup.controls.telephone"
            data-at-telephone-edit
            fieldTextContentTooltip
            [disabled]="isOmaUser"
          />
          <mat-error *ngIf="formGroup.controls.telephone.hasError('pattern')">
            <!-- Telephone number must start with + and has digits -->
            {{ '+USER_DETAILS.VALIDATION.TELEPHONE.INVALID' | translate }}
          </mat-error>
          <mat-error
            *ngIf="
              !formGroup.controls.telephone.hasError('pattern') &&
              formGroup.controls.telephone.hasError('minlength')
            "
          >
            <!-- Telephone number is too short -->
            {{ '+USER_DETAILS.VALIDATION.TELEPHONE.MINLENGTH' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="flex flex-row">
        <mat-form-field mat-input-height-large-label class="flex-[100%] max-w-[100%]" id="mobile">
          <mat-label>{{ '+USER_DETAILS.PERSONAL_DETAILS.MOBILE_PHONE' | translate }}</mat-label>
          <input
            gtm="onTextField"
            gtmId="mobile"
            gtmAction="Mobile"
            gtmCategory="userContactDetails"
            [gtmOn]="['change', 'focus', 'blur']"
            matInput
            [formControl]="formGroup.controls.mobile"
            data-at-mobile-edit
            fieldTextContentTooltip
          />
          <mat-error *ngIf="formGroup.controls.mobile.hasError('pattern')">
            <!-- Mobile number must start with + and has digits -->
            {{ '+USER_DETAILS.VALIDATION.MOBILE_PHONE.INVALID' | translate }}
          </mat-error>
          <mat-error
            *ngIf="
              !formGroup.controls.mobile.hasError('pattern') &&
              formGroup.controls.mobile.hasError('minlength')
            "
          >
            <!-- Mobile number is too short -->
            {{ '+USER_DETAILS.VALIDATION.MOBILE_PHONE.MINLENGTH' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </form>
  </mat-card-content>
  <mat-card-actions class="flex flex-row gap-[8px] justify-end items-center" align="end">
    <button
      id="cancel-btn"
      mat-button
      color="primary"
      gtm="onCancelDialog"
      gtmCategory="userContactDetails"
      (click)="onCancel()"
    >
      {{ 'GENERAL.BUTTON.CANCEL' | translate }}
    </button>
    <button
      id="save-btn"
      mat-raised-button
      color="primary"
      [disabled]="formGroup.invalid"
      gtm="onSave"
      gtmCategory="userContactDetails"
      (click)="dispatchSave()"
    >
      {{ 'GENERAL.BUTTON.SAVE' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
